import APIService from '@/services/APIService';

export default {
  historico() {
    return APIService.apiCall().get('/aieJustificativas/historico');
  },
  importar(arquivo) {
    const dados = new FormData();
    dados.append('file', arquivo);
    return APIService.apiCall().post('/aieJustificativas/importar', dados, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  modelo() {
    return APIService.apiCall().get('/aieJustificativas/modelo', {
      responseType: 'blob', timeout: 2 * 60 * 1000
    });
  },
  baixar(id, tipo) {
    return APIService.apiCall().get(`/aieJustificativas/baixar/${id}/${tipo}`, {
      responseType: 'blob', timeout: 10 * 60 * 1000
    });
  }
};
